module.exports = __webpack_public_path__ + "img/arrow_left_square.34164a74.svg";